<template>
  <div id="orderDetail" style="min-height:750px;" v-if="orderDetail">
    <div class="details_box ws" id="printTest">
      <ul>
        <li class="num1">
          <div class="l">
            <span class="first">orderNo:</span>
            <span>{{orderDetail.orderId}}</span>
          </div>
          <div class="l">
            <span class="first">price:</span>
            <span>{{"$"+orderDetail.totalFree}}</span>
            <span
              style="margin-left:3.2rem;"
              class="delete"
              @click="handledelete(orderDetail.orderId)"
            >delete</span>
          </div>
        </li>
        <li class="num2">
          <div class="l">
            <span class="first">date:</span>
            <span>{{orderDetail.createDate}}</span>
          </div>
          <div class="l">
            <span class="first">states:</span>
            <span v-if="orderDetail.status == '1'">Unpaid</span>
            <span v-if="orderDetail.status !== '1'">Paid</span>
          </div>
        </li>
        <li class="num3">
          <div class="l">
            <span class="first">address:</span>
            <span>{{orderDetail.address}}</span>
          </div>
          <div class="l">
            <span class="first">GST:</span>
            <span>${{this.handleGst()}}</span>
          </div>
        </li>
        <li class="num3">
          <div>
            <span class="first">pay:</span>
            <span v-if="orderDetail.status == '1'">
              <a href="#" @click="handleagain(orderDetail.orderId,orderDetail.totalFree)">Pay again</a>
            </span>
          </div>
        </li>
        <li class="num4" v-if="orderDetail.status !== '1'">
          <button @click="getPdf(htmlTitle)">Export Invoice</button>
        </li>
      </ul>
    </div>
    <ul class="goods ws">
      <li class="first">
        <span class="num1">commodity</span>
        <span class="num2">Trade name</span>
        <span>Price</span>
        <span style="width:11%;">Number</span>
        <span style="width:11%;">GST</span>
        <span style="width:11%;">Total price</span>
      </li>
      <li class="goods_text" v-for="(data,index) in orderDetail.goodsInfo" :key="index">
        <div class="commodity l">
          <img :src="data.goodsImg" alt />
        </div>
        <div class="trade_name l">{{data.goodsEnglishName}}</div>
        <div class="price l">{{'$'+data.price}}</div>
        <div class="number l" style="width:11%;">{{data.goodsAccount}}</div>
        <div
          class="Gst l"
          style="width:11%;"
          v-if="data.isGst == '1'"
        >{{'$'+ Math.round( (data.price*0.1*data.goodsAccount) * 100) / 100}}</div>
        <div class="Gst l" style="width:11%;" v-if="data.isGst !== '1'">$0</div>
        <div
          class="total_price l"
          style="width:11%;"
        >{{'$'+ Math.round( (data.goodsAccount*data.price ) * 100) / 100}}</div>
      </li>
    </ul>
    <!-- v-show="$store.state.isshowPdf" -->
    <div class="header" id="pdfDom" v-show="$store.state.isshowPdf">
      <div class="logo l pdf">
        <img src="../../public/img/Icon6.png" alt />
      </div>
      <div class="center l pdf">
        <h1>TAX INVOICE</h1>
      </div>
      <div class="address l pdf">
        <p>ABN：46 612 389 143</p>
        <p>Address：2/489Nicholson Rd,Canningvale WA 6155</p>
        <p>PH：(08)6113 6617</p>
        <p>
          <a href="#">admin@awesomewarehouse.com.cn</a>
        </p>
        <p>
          <a href="#">https://www.awesomewholesale.com.au</a>
        </p>
      </div>
      <div class="both" style="clear:both;"></div>
      <div class="invoice l pdf" style="height:1rem;"> <p>Invoice No:{{orderDetail.orderId}}</p> <p>Bill TO:</p> </div>
      <div class="invoice l pdf"> <p> Invoice Date:{{orderDetail.createDate}}</p></div>
        <!-- <div class="invoice l pdf"></div> -->
      <div class="invoice l pdf" style="padding-left:.2rem;">
        <p>
          ABN:
          <span>{{this.ABN}}</span>
        </p>
        <p>
          Invoice to:
          <span>{{orderDetail.receivingUserName}}</span>
        </p>
        <p>
          Delivery Address:
          <span>{{orderDetail.address}}</span>
        </p>
      </div>
      <div class="invoice l pdf"></div>
      <div class="both" style="clear:both;"></div>
      <!-- <p class="sales" style="height: 60px; margin-left:280px;">Sales Rep：</p> -->
      <ul class="product">
        <li class="products" style="border-bottom:2px solid black; font-weight:600;">
          <span class="num1">Product Description</span>
          <span class="num2">Product Code</span>
          <span class="num3">Qty</span>
          <span class="num4">Unit Price</span>
          <span class="num5">Disc</span>
          <span class="num6">W/sale</span>
          <span class="num7">GST</span>
          <span class="num8">Sub Total</span>
        </li>
        <li
          class="products"
          style="border-bottom:2px solid #ccc;"
          v-for="(data,index) in orderDetail.goodsInfo"
          :key="index"
        >
          <span class="num1">{{data.goodsEnglishName}}</span>
          <span class="num2">{{data.goodsCode}}</span>
          <span class="num3">{{data.goodsAccount}}</span>
          <span class="num4">{{'$'+data.reducedPrice }}</span>
          <span class="num5">{{data.reducedRate*100+"%"}}</span>
          <span class="num6">{{'$'+data.price}}</span>
          <span class="num7" v-if="data.isGst == '1'">${{ (data.goodsAccount*data.price*0.1).toFixed(2)}}</span>
          <span class="num7" v-if="data.isGst !== '1'">$0</span>
          <span class="num8">{{'$'+data.goodsAccount*data.price}}</span>
        </li>
        <li
          class="products"
          style="text-align:right;line-height: 40px;  font-weight:600;"
        >
          <span style="width:12%;text-align: left;">Total withhout GST：</span>
          <span>${{this.handlePage() - this.handleGst()}}</span>
        </li>
        <li
          class="products"
          style="text-align:right;line-height: 40px;  font-weight:600;"
        >
          <span style="width:12%;text-align: left;">Total GST：</span>
          <span>${{this.handleGst()}}</span>
        </li>
        <li
          class="products"
          style="text-align:right;line-height: 40px;  font-weight:600;"
        >
          <span style="width:12%;text-align: left;">Freight：</span>
          <span>${{orderDetail.freightFree}}</span>
        </li>
        <li
          class="products"
          style="text-align:right;line-height: 40px;  font-weight:600;"
        >
          <span style="width:12%;text-align: left;">Total with GST:</span>
          <span>${{this.handlePage()}}</span>
        </li>
      </ul>
      <div class="news">
        <p>Bank Account Details:</p>
        <p>GNG International Trading Pty Ltd</p>
        <p>Commonwealth</p>
        <p>BSB:066-134</p>
        <p>ACCOUNT:1098 3881</p>
      </div>
      <!-- <div class="both" style="clear:both;"></div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data () {
    return {
      htmlTitle: "",
      orderDetail: null,
      ABN: localStorage.getItem("ABN")
    };
  },
  mounted () {
    this.htmlTitle = this.$route.params.myorder
    axios
      .get(
        `${this.APi}/api/v1/shopping/orders/details/${this.$route.params.myorder}`,
        {
          headers: { token: localStorage.getItem("token") }
        }
      )
      .then(res => {
        this.orderDetail = res.data.result;
      });
  },
  methods: {
    handleagain (id, price) {
      sessionStorage.setItem("orderId", id);

      price = parseFloat(price);

      var freight = 10;
      if (price > 500) {
        freight = 0;
        // eslint-disable-next-line no-self-assign
        price = price;
        this.$router.push({
          name: "settlementPage",
          query: { orderId: id, price: price, freight: freight }
        });
      } else {
        // eslint-disable-next-line no-self-assign
        price = price;
        this.$router.push({
          name: "settlementPage",
          query: { orderId: id, price: price, freight: freight }
        });
      }
    },
    handledelete (id) {
      axios
        .delete(`${this.APi}/api/v1/shopping/order/delete/${id}`, {
          headers: { token: localStorage.getItem("token") }
        })
        .then(res => {
          if (res.data.code == "200") {
            this.$router.push("/myorder");
          }
        });
    },
    // 总金额
    handlePage () {
      var allPrice = 0;
      for (var i = 0; i < this.orderDetail.goodsInfo.length; i++) {
        allPrice +=
          this.orderDetail.goodsInfo[i].goodsAccount *
          this.orderDetail.goodsInfo[i].price;
      }
      allPrice = (allPrice + parseInt(this.orderDetail.freightFree)).toFixed(2);
      return allPrice;
    },
    // 总税费
    handleGst () {
      var newArr = this.orderDetail.goodsInfo.filter(item => item.isGst != 0);
      var allGst = 0;
      for (var i = 0; i < newArr.length; i++) {
        allGst += newArr[i].goodsAccount * newArr[i].price * 0.1;
      }
      allGst = parseFloat(allGst.toFixed(2))
      return allGst;
    }
  }
};
</script>

<style lang="scss" scoped>
#orderDetail {
  .details_box {
    margin-top: 0.375rem;
    margin-bottom: 0.375rem;
    padding: 0.25rem;
    border: 2px solid #999;
    ul {
      li {
        color: #a09e9c;
        font-weight: 500;
        overflow: hidden;
        padding: 0.125rem 0;
        div {
          width: 50%;
          span.first {
            display: inline-block;
            margin-right: 0.125rem;
            width: 1rem;
          }
          span.delete {
            cursor: pointer;
            &:hover {
              color: red;
            }
          }
        }
        button {
          outline: none;
          border: 0;
          background: #d8684c;
          color: #fff;
          height: 0.4375rem;
          border-radius: 0.0625rem;
          margin-top: 0.125rem;
        }
      }
    }
  }
  .goods {
    padding: 0.25rem;
    border: 1px solid #eee;
    color: #a09e9c;
    li {
      border-bottom: 1px solid #eee;
    }
    li.first {
      // font-size: 0.15rem;
      color: black;
      span {
        display: inline-block;
        width: 17%;
        text-align: center;
      }
      span.num1 {
        text-align: left;
      }
      span.num2 {
        width: 32%;
      }
    }
    li.goods_text {
      padding: 0.4375rem 0;
      overflow: hidden;
      div {
        width: 17%;
        text-align: center;
      }
      div.trade_name {
        width: 32%;
      }
      div.commodity {
        img {
          width: 0.625rem;
        }
      }
    }
  }

  .header {
    transform: scale(0.7, 0.7);
    .pdf {
      width: 6.325rem;
    }
    .logo {
      img {
        width: 3.25rem;
      }
    }
    .center {
      h1 {
        text-align: center;
        box-sizing: border-box;
        padding-top: 1.825rem;
        font-size: 0.625rem;
      }
    }
    .address {
      box-sizing: border-box;
      padding-left: 1.537rem;
      padding-top: 0.4375rem;
      p {
        margin-bottom: 0;
      }
    }
    .invoice {
      // display: none;
      height: 1.25rem;
      width: 50%;
      line-height: 1.25rem;
      // text-align: center;
      font-weight: 600;
      p {
        line-height: 0.375rem;
        margin-bottom: 0;
      }
    }
    .product {
      // display: none;
      .products {
        width: 100%;
        margin: 0;
        span {
          display: inline-block;
          width: 9.8%;
          text-align: center;
          line-height: 0.5rem;
        }
        span.num1 {
          text-align: left;
          width: 31%;
        }
      }
    }
    .news {
      // display: none;
      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
